<template>
  <div class="range-slider-container">
    <label class="slider-main-label">Filtrar preço</label>
    <div class="slider-track-base">
      <div class="slider-track-fill" :style="fillStyles"></div>
      
      <input 
        type="range" 
        :value="modelValue[0]" 
        :min="min" 
        :max="max" 
        :step="step"
        class="range-input"
        @input="updateMin"
      />
      
      <input 
        type="range" 
        :value="modelValue[1]" 
        :min="min" 
        :max="max" 
        :step="step"
        class="range-input"
        @input="updateMax"
      />
    </div>

    <div class="range-labels">
      <span>Mín: {{ modelValue[0].toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</span>
      <span>Máx: {{ modelValue[1].toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RangeSlider',
  props: {
    // No Vue 3, o v-model padrão usa a prop 'modelValue'
    modelValue: {
      type: Array,
      default: () => [25, 75]
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    }
  },
  emits: ['update:modelValue'],
  computed: {
    // Calcula a posição e largura da barra verde (track-fill)
    fillStyles() {
      const low = this.modelValue[0];
      const high = this.modelValue[1];
      
      const percent1 = ((low - this.min) / (this.max - this.min)) * 100;
      const percent2 = ((high - this.min) / (this.max - this.min)) * 100;
      
      return {
        left: percent1 + '%',
        width: (percent2 - percent1) + '%'
      };
    }
  },
  methods: {
    updateMin(event) {
      const val = Number(event.target.value);
      // Impede que o mínimo ultrapasse o máximo
      const newMax = Math.max(val, this.modelValue[1]);
      this.$emit('update:modelValue', [val, newMax]);
    },
    updateMax(event) {
      const val = Number(event.target.value);
      // Impede que o máximo seja menor que o mínimo
      const newMin = Math.min(val, this.modelValue[0]);
      this.$emit('update:modelValue', [newMin, val]);
    }
  }
};
</script>

<style scoped>
.range-slider-container {
  position: relative;
  width: 100%;
  padding: 30px 0;
}

/* Estilo do novo label */
.slider-main-label {
  display: block;
  margin-bottom: 15px;
  font-size: 1rem;
}

.slider-track-base {
  position: relative;
  width: 100%;
  height: 6px;
  background-color: #e2e8f0;
  border-radius: 999px;
}

.slider-track-fill {
  position: absolute;
  height: 100%;
  background-color: #CCCCCC; /* Cor do Vue */
  border-radius: 999px;
  z-index: 1;
}

.range-input {
  position: absolute;
  width: 100%;
  height: 6px;
  top: 0;
  left: 0;
  background: none;
  pointer-events: none; /* Ignora cliques na barra para não bloquear o outro input */
  appearance: none;
  margin: 0;
  z-index: 2;
}

/* Estilização do seletor (Thumb) */
/* Webkit (Chrome, Safari, Edge) */
.range-input::-webkit-slider-thumb {
  appearance: none;
  pointer-events: auto; /* Reativa o clique apenas na bolinha */
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #333333;
  border: 2px solid #ffffff;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  transition: transform 0.1s ease;
}

.range-input::-webkit-slider-thumb:active {
  transform: scale(1.2);
}

/* Firefox */
.range-input::-moz-range-thumb {
  pointer-events: auto;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #2c3e50;
  border: 2px solid #ffffff;
  cursor: pointer;
}

.range-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  font-family: Arial, sans-serif;
  color: #475569;
  font-size: 14px;
}
</style>
